import gql from 'graphql-tag';
import { surfaceDetailsFragment } from 'graphql/surface/fragments/surface-fragment';

export const surfaceUnionIdFragment = gql`
  fragment surfaceNodeUnionId on SurfaceNodeUnion {
    ... on SurfaceTextNode {
      id
    }
    ... on SurfaceTextNodeSnippet {
      id
    }
    ... on SurfaceDocumentNodeSnippet {
      id
    }
    ... on SurfaceImageNode {
      id
    }
    ... on SurfaceBackgroundNode {
      id
    }
    ... on SurfaceDocumentNode {
      id
    }
    ... on SurfaceNoteNode {
      id
    }
    ... on SurfaceProtocolNode {
      id
    }
    ... on SubSurfaceNode {
      id
    }
    ... on SurfaceQuestionnaireNode {
      id
    }
  }
`;

// export const surfaceBackgroundNodeFragment = gql`
//   fragment surfaceBackgroundNodeDetails on SurfaceBackgroundNode {
//     id
//     name
//     url
//     isReference
//     #hasReferences
//     imageFormat: format
//     originalNode {
//       ...surfaceNodeUnionId
//     }
//     surface {
//       ...surfaceDetails
//     }
//     position {
//       ...positionDetails
//     }
//     pointsTo {
//       ...pointsToDetails
//     }
//     type
//     createdBy
//     createdAt
//     updatedAt
//     ownedBy
//     isLocked
//     lockedBy
//     lockedAt
//     fetchedAt
//   }
//   ${surfaceNodePositionFragment}
//   ${surfaceNodePointsToFragment}
//   ${surfaceDetailsFragment}
//   ${surfaceUnionIdFragment}
// `;


export const surfaceUnionIdWithSurfaceIdFragment = gql`
  fragment surfaceNodeUnionIdWithSurfaceId on SurfaceNodeUnion {
    ... on SurfaceTextNode {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceTextNodeSnippet {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceBackgroundNode {
      id
      name
      references {
        ... on SurfaceBackgroundNode {
          id
          name
        }
      }
    }
    ... on SurfaceDocumentNodeSnippet {

      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceImageNode {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceDocumentNode {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceNoteNode {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceProtocolNode {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SubSurfaceNode {
      id
      surface {
        ...surfaceDetails
      }
    }
    ... on SurfaceQuestionnaireNode {
      id
      surface {
        ...surfaceDetails
      }
    }
  }
  ${surfaceDetailsFragment}
`;
